import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 24,
      height: '100%',
    },
    text: {
      fontSize: '32px',
      lineHeight: '38px',
    },
    button: {
      marginTop: 'auto',
      fontSize: '16px',

      [theme.breakpoints.up('md')]: {
        marginBottom: '5%',
        padding: theme.spacing(2),
        width: 'auto'
      },
    },
  })
);
